module.exports = __webpack_public_path__ + "static/media/kuehlregal_on.1a9b3980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/food-store/kuehlregal_on.png
// module id = 504
// module chunks = 0